import { Link } from '@tanstack/react-router';
import { ArrowRight, Info, UserPlus } from 'lucide-react';
import LogoImage from '@/shared/assets/images/logo.png';
import { Button } from '@/shared/ui/button';

export const HomePage = () => {
  return (
    <main className="relative flex min-h-screen items-center justify-center bg-[#091326] px-5 py-12 text-slate-50">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.35),transparent_55%),radial-gradient(circle_at_bottom_right,rgba(14,116,144,0.25),transparent_50%),#0b1934]" />
      <div className="pointer-events-none absolute inset-0 bg-[url('https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=2940&auto=format&fit=crop')] bg-cover bg-center opacity-10" />

      <section className="relative z-10 flex w-full max-w-[420px] flex-col items-center gap-5 text-center">
        <div className="grid h-20 w-20 place-items-center rounded-3xl bg-white/10 p-3 shadow-[0_20px_45px_rgba(37,99,235,0.35)] backdrop-blur">
          <img
            src={LogoImage}
            alt="JIGO Ed logo"
            className="h-full w-full object-contain"
            loading="lazy"
          />
        </div>

        <h1 className="text-2xl font-bold tracking-tight text-white">
          JIGO Ed
        </h1>

        <div className="w-full rounded-[28px] border border-white/20 bg-white/10 p-7 shadow-[0_35px_80px_rgba(15,23,42,0.35)] backdrop-blur-2xl">
          <h2 className="text-xl font-semibold leading-snug text-white">
            Washington Real Estate Continued Education
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-200/85">
            State-approved continuing education courses for 2nd time real estate
            license renewals.
          </p>

          <div className="mt-6 grid gap-3">
            <Button
              asChild
              size="lg"
              className="flex h-11 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-[#2563eb] to-[#1d4ed8] text-sm font-semibold shadow-[0_18px_40px_rgba(37,99,235,0.35)]"
            >
              <Link to="/sign-in" search={{ redirect: undefined }}>
                <ArrowRight className="h-4 w-4" aria-hidden />
                Sign In
              </Link>
            </Button>

            <Button
              asChild
              variant="outline"
              size="lg"
              className="flex h-11 w-full items-center justify-center gap-2 rounded-2xl border-white/35 bg-white/10 text-sm font-semibold text-white hover:bg-white/15"
            >
              <Link to="/register">
                <UserPlus className="h-4 w-4" aria-hidden />
                Create Account
              </Link>
            </Button>
          </div>

          <div className="mt-5 flex items-start gap-2.5 rounded-2xl border border-amber-400/60 bg-amber-500/10 px-3.5 py-3 text-left text-sm text-amber-100">
            <Info
              className="mt-0.5 h-4 w-4 shrink-0 text-amber-300"
              aria-hidden
            />
            <p>
              Important: These courses are exclusively for Washington State real
              estate license renewals.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};
